import { faSignature } from '@fortawesome/pro-regular-svg-icons';
import { RoundedCheckbox, SceneWrapper } from '~/components';
import {
  ButtonComponent,
  CheckboxWrapper,
  ContentWrapper,
  IconComponent,
  StyledLink,
  Subtitle,
  Title,
} from './styles';

interface OnboardingContractResumeProps {
  agreeWithContract: boolean;
  setAgreeWithContract: (value: boolean) => void;
  seeContract: () => void;
  handleNext: () => Promise<void>;
}

const OnboardingContractResume = ({
  agreeWithContract,
  setAgreeWithContract,
  seeContract,
  handleNext,
}: OnboardingContractResumeProps) => {
  return (
    <SceneWrapper
      footer={
        <ButtonComponent
          id="onboarding-contract-resume-button"
          onPress={handleNext}
          fullWidth
          disabled={!agreeWithContract}
        >
          LI E ESTOU DE ACORDO
        </ButtonComponent>
      }
    >
      <ContentWrapper>
        <IconComponent icon={faSignature} />
        <Title>Contrato</Title>
        <Subtitle>É importante que você conheça e aceite:</Subtitle>
        <CheckboxWrapper>
          <RoundedCheckbox
            checked={agreeWithContract}
            onChange={setAgreeWithContract}
            name="proposta"
          />
          <StyledLink onClick={seeContract}>
            Proposta de abertura de crédito
          </StyledLink>
        </CheckboxWrapper>
      </ContentWrapper>
    </SceneWrapper>
  );
};

export default OnboardingContractResume;
